var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9757 12.2185C13.1602 12.4314 13.1488 12.7507 12.9496 12.9499C12.7504 13.1491 12.4311 13.1605 12.2182 12.976L7.42275 8.8199C7.33649 8.74514 7.26069 8.65912 7.19738 8.56415L6.13406 6.96918C6.02485 6.80536 6.14228 6.58594 6.33916 6.58594C6.47531 6.58594 6.58567 6.47557 6.58567 6.33943C6.58567 6.14255 6.8051 6.02511 6.96891 6.13432L8.56389 7.19764C8.65886 7.26095 8.74488 7.33676 8.81963 7.42301L12.9757 12.2185Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75702 5.17171C2.97597 4.39067 4.464 4.46474 3.04978 3.05053C4.46439 3.05066 5.17124 3.7575 5.17124 3.7575C5.95228 4.53855 6.26866 5.4885 5.87821 5.87895C5.48776 6.2694 4.53807 5.95276 3.75702 5.17171Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgColor);
export default __webpack_public_path__ + "static/media/Bg_color.888f3e69fced89e446ba3996dc2abba4.svg";
export { ForwardRef as ReactComponent };